import { LocalReportCreateVersionModal as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './LocalReportCreateVersionModal.proptype';

export const LocalReportCreateNewVersion = (props: LocalReportCreateVersionModalProps) => (
  <Connector {...props} component={Component} />
);

export interface LocalReportCreateVersionModalProps extends Omit<ConnectorProps, 'component'> {}
